//  ---------------- Old Card swiper code for swiper slider in collection page ---------------- 
// (() => {
//     function initOne(el) {
//       if (el.dataset.swiperInit === '1') return;
//       if (!window.Swiper) return;

//       el.dataset.swiperInit = '1';

//       const nextEl = el.querySelector('.pcarousel-nav.next');
//       const prevEl = el.querySelector('.pcarousel-nav.prev');

//       const sw = new Swiper(el, {
//         slidesPerView: 1,
//         resistanceRatio: 0.85,
//         effect: 'slide',
//         speed: 260,
//         watchOverflow: true,
//         observer: false,
//         observeParents: false,
//         preloadImages: false,
//         navigation: (nextEl && prevEl) ? { nextEl, prevEl } : undefined
//       });

//       /* ✅ MOST IMPORTANT LINE (view1 / view2 sync) */
//       if (sw.slides && sw.slides.length >= 2) {
//         sw.slideTo(window.__isView2Active ? 1 : 0, 0);
//       }

//       (window._cardSwipers ||= []).push(sw);
//       el.__swiper_instance = sw;
//     }

//     function initCardSwipers(root = document) {
//       const els = root.querySelectorAll('[data-swiper-card]');

//       if (!('IntersectionObserver' in window)) {
//         els.forEach(initOne);
//         return;
//       }

//       const io = new IntersectionObserver((entries) => {
//         entries.forEach((e) => {
//           if (e.isIntersecting) {
//             initOne(e.target);
//             io.unobserve(e.target);
//           }
//         });
//       }, { rootMargin: '250px 0px' });

//       els.forEach(el => {
//         if (el.dataset.swiperInit === '1') return;
//         io.observe(el);
//       });
//     }

//     function boot() {
//       initCardSwipers(document);
//     }

//     document.addEventListener('DOMContentLoaded', () => {
//       const t0 = Date.now();
//       (function waitForSwiper() {
//         if (window.Swiper) return boot();
//         if (Date.now() - t0 > 4000) return;
//         setTimeout(waitForSwiper, 50);
//       })();
//     });

//     document.addEventListener('shopify:section:load', (e) => {
//       initCardSwipers(e.target);
//     });

//     /* ✅ clean destroy on section unload */
//     document.addEventListener('shopify:section:unload', (e) => {
//       e.target.querySelectorAll('[data-swiper-card]').forEach(el => {
//         const sw = el.__swiper_instance;
//         if (sw && typeof sw.destroy === 'function') {
//           try { sw.destroy(true, true); } catch {}
//         }
//         delete el.__swiper_instance;
//         el.removeAttribute('data-swiper-init');
//       });

//       if (window._cardSwipers) {
//         window._cardSwipers = window._cardSwipers.filter(sw => sw && !sw.destroyed);
//       }
//     });
//   })();

//  ---------------- Old Card swiper code for swiper slider in collection page ---------------- 






//  ---------------- Ye code Hover pe 2nd Image show karta hai card ma ---------------- 
// (() => {
//     const desktopMQ = window.matchMedia('(min-width: 750px)');

//     function initOne(el) {
//       if (el.dataset.swiperInit === '1') return;
//       if (!window.Swiper) return;

//       el.dataset.swiperInit = '1';

//       const nextEl = el.querySelector('.pcarousel-nav.next');
//       const prevEl = el.querySelector('.pcarousel-nav.prev');

//       const sw = new Swiper(el, {
//         slidesPerView: 1,
//         resistanceRatio: 0.85,
//         effect: 'slide',
//         speed: 260,
//         watchOverflow: true,
//         observer: false,
//         observeParents: false,
//         preloadImages: false,

//         /* Mobile = original slider */
//         allowTouchMove: true,

//         navigation: (nextEl && prevEl)
//           ? { nextEl, prevEl }
//           : undefined,

//         /* Desktop settings */
//         breakpoints: {
//           750: {
//             allowTouchMove: false,
//             speed: 0
//           }
//         }
//       });

//       /* View 1 / View 2 sync */
//       const syncView = () => {
//         if (sw.destroyed || !sw.slides || sw.slides.length < 2) return;

//         sw.slideTo(
//           window.__isView2Active ? 1 : 0,
//           0
//         );
//       };

//       syncView();

//       /* Desktop hover only */
//       const handleMouseEnter = () => {
//         if (!desktopMQ.matches || sw.destroyed) return;

//         sw.slideTo(
//           window.__isView2Active ? 0 : 1,
//           0
//         );
//       };

//       const handleMouseLeave = () => {
//         if (!desktopMQ.matches || sw.destroyed) return;

//         syncView();
//       };

//       el.addEventListener('mouseenter', handleMouseEnter);
//       el.addEventListener('mouseleave', handleMouseLeave);

//       /*
//         Desktop ↔ Mobile resize:
//         current View 1 / View 2 image ko reset/sync karo
//       */
//       const handleBreakpointChange = () => {
//         syncView();
//       };

//       desktopMQ.addEventListener('change', handleBreakpointChange);

//       el.__swiperMouseEnter = handleMouseEnter;
//       el.__swiperMouseLeave = handleMouseLeave;
//       el.__swiperBreakpointChange = handleBreakpointChange;

//       (window._cardSwipers ||= []).push(sw);
//       el.__swiper_instance = sw;
//     }

//     function initCardSwipers(root = document) {
//       const els = root.querySelectorAll('[data-swiper-card]');

//       if (!('IntersectionObserver' in window)) {
//         els.forEach(initOne);
//         return;
//       }

//       const io = new IntersectionObserver((entries) => {
//         entries.forEach((e) => {
//           if (e.isIntersecting) {
//             initOne(e.target);
//             io.unobserve(e.target);
//           }
//         });
//       }, { rootMargin: '250px 0px' });

//       els.forEach(el => {
//         if (el.dataset.swiperInit === '1') return;
//         io.observe(el);
//       });
//     }

//     function boot() {
//       initCardSwipers(document);
//     }

//     document.addEventListener('DOMContentLoaded', () => {
//       const t0 = Date.now();

//       (function waitForSwiper() {
//         if (window.Swiper) return boot();
//         if (Date.now() - t0 > 4000) return;

//         setTimeout(waitForSwiper, 50);
//       })();
//     });

//     document.addEventListener('shopify:section:load', (e) => {
//       initCardSwipers(e.target);
//     });

//     document.addEventListener('shopify:section:unload', (e) => {
//       e.target.querySelectorAll('[data-swiper-card]').forEach(el => {
//         if (el.__swiperMouseEnter) {
//           el.removeEventListener('mouseenter', el.__swiperMouseEnter);
//         }

//         if (el.__swiperMouseLeave) {
//           el.removeEventListener('mouseleave', el.__swiperMouseLeave);
//         }

//         if (el.__swiperBreakpointChange) {
//           desktopMQ.removeEventListener(
//             'change',
//             el.__swiperBreakpointChange
//           );
//         }

//         const sw = el.__swiper_instance;

//         if (sw && typeof sw.destroy === 'function') {
//           try {
//             sw.destroy(true, true);
//           } catch {}
//         }

//         delete el.__swiper_instance;
//         delete el.__swiperMouseEnter;
//         delete el.__swiperMouseLeave;
//         delete el.__swiperBreakpointChange;

//         el.removeAttribute('data-swiper-init');
//       });

//       if (window._cardSwipers) {
//         window._cardSwipers = window._cardSwipers.filter(
//           sw => sw && !sw.destroyed
//         );
//       }
//     });
//   })();
//  ---------------- Ye code Hover pe 2nd Image show karta hai card ma ---------------- 













(() => {
  const desktopMQ = window.matchMedia('(min-width: 750px)');
  const reducedMotionMQ = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const selector =
    '.card__media .media.media--hover-effect';


  /* =========================================
     SET ACTIVE IMAGE
  ========================================= */

  function setImage(state, index) {
    index =
      Number(index) === 1 &&
      state.images.length > 1
        ? 1
        : 0;

    state.index = index;

    state.images.forEach((img, i) => {
      img.style.setProperty(
        'opacity',
        i === index ? '1' : '0',
        'important'
      );
    });
  }


  /* =========================================
     CURRENT VIEW IMAGE

     View 1 = Image 1
     View 2 = Image 2
  ========================================= */

  function getBaseIndex(state) {
    return (
      window.__isView2Active &&
      state.images.length > 1
    )
      ? 1
      : 0;
  }


  /* =========================================
     MOBILE SLIDE EFFECT
  ========================================= */

  function slideImage(
    state,
    nextIndex,
    direction
  ) {

    if (state.animating) return;

    if (nextIndex === state.index) return;


    const current =
      state.images[state.index];

    const next =
      state.images[nextIndex];


    if (!current || !next) return;


    /*
      Reduced-motion users:
      direct image switch.
    */
    if (
      reducedMotionMQ.matches ||
      typeof current.animate !== 'function'
    ) {

      setImage(
        state,
        nextIndex
      );

      return;
    }


    state.animating = true;


    /*
      Animation ke waqt
      dono images visible.
    */
    current.style.setProperty(
      'opacity',
      '1',
      'important'
    );

    next.style.setProperty(
      'opacity',
      '1',
      'important'
    );


    const outgoingX =
      direction === 'left'
        ? '-100%'
        : '100%';

    const incomingX =
      direction === 'left'
        ? '100%'
        : '-100%';


    const outgoing =
      current.animate(
        [
          {
            transform:
              'translateX(0)'
          },
          {
            transform:
              `translateX(${outgoingX})`
          }
        ],
        {
          duration: 260,
          easing: 'ease-out'
        }
      );


    const incoming =
      next.animate(
        [
          {
            transform:
              `translateX(${incomingX})`
          },
          {
            transform:
              'translateX(0)'
          }
        ],
        {
          duration: 260,
          easing: 'ease-out'
        }
      );


    Promise.allSettled([
      outgoing.finished,
      incoming.finished
    ]).then(() => {

      setImage(
        state,
        nextIndex
      );

      state.animating = false;

    });
  }


  /* =========================================
     SETUP ONE PRODUCT CARD
  ========================================= */

  function setup(media) {

    /*
      Duplicate initialization prevent.
    */
    if (media.__viewSwitchState) {
      return;
    }


    const images =
      Array.from(media.children)
        .filter(
          el => el.tagName === 'IMG'
        )
        .slice(0, 2);


    if (!images.length) {
      return;
    }


    /*
      Card wrapper use kar rahe hain
      taa-ke Dawn ka card__content overlay
      mouse/touch ko block na kare.
    */
    const card =
      media.closest('.card-wrapper') ||
      media.closest('.card') ||
      media;


    const state = {
      images,
      index: 0,
      touch: null,
      animating: false,
      suppressClickUntil: 0
    };


    /* =========================================
       VIEW 1 / VIEW 2 CONTROLLER
    ========================================= */

    const controller = {

      destroyed: false,

      slides: images,


      get activeIndex() {
        return state.index;
      },


      slideTo(index) {

        setImage(
          state,
          index
        );

      },


      update() {},


      destroy() {
        this.destroyed = true;
      },


      __cardController: true
    };


    media.__viewSwitchState =
      state;


    (window._cardSwipers ||= [])
      .push(controller);


    /*
      Initial View
    */
    setImage(
      state,
      getBaseIndex(state)
    );


    /* =========================================
       DESKTOP HOVER

       View 1:
       normal = Image 1
       hover  = Image 2

       View 2:
       normal = Image 2
       hover  = Image 1
    ========================================= */

    card.addEventListener(
      'mouseenter',
      () => {

        if (
          !desktopMQ.matches ||
          images.length < 2
        ) {
          return;
        }


        setImage(
          state,
          window.__isView2Active
            ? 0
            : 1
        );

      }
    );


    card.addEventListener(
      'mouseleave',
      () => {

        if (!desktopMQ.matches) {
          return;
        }


        setImage(
          state,
          getBaseIndex(state)
        );

      }
    );


    /* =========================================
       MOBILE TOUCH START
    ========================================= */

    card.addEventListener(
      'touchstart',
      (event) => {

        if (
          desktopMQ.matches ||
          images.length < 2 ||
          state.animating
        ) {
          return;
        }


        /*
          IMPORTANT:

          2+ fingers = pinch zoom.

          Purana swipe state immediately
          clear kar do.
        */
        if (
          event.touches.length !== 1
        ) {

          state.touch = null;

          return;
        }


        const touch =
          event.touches[0];


        const rect =
          media.getBoundingClientRect();


        /*
          Swipe sirf product image area
          se start hona chahiye.
        */
        if (
          touch.clientX < rect.left ||
          touch.clientX > rect.right ||
          touch.clientY < rect.top ||
          touch.clientY > rect.bottom
        ) {

          state.touch = null;

          return;
        }


        state.touch = {

          startX:
            touch.clientX,

          startY:
            touch.clientY

        };

      },
      {
        passive: true
      }
    );


    /* =========================================
       MOBILE TOUCH MOVE

       Pinch start hote hi swipe cancel.
    ========================================= */

    card.addEventListener(
      'touchmove',
      (event) => {

        if (desktopMQ.matches) {
          return;
        }


        /*
          Second finger detect hui:
          ye swipe nahi, pinch hai.
        */
        if (
          event.touches.length !== 1
        ) {

          state.touch = null;

        }

      },
      {
        passive: true
      }
    );


    /* =========================================
       MOBILE TOUCH END
    ========================================= */

    card.addEventListener(
      'touchend',
      (event) => {

        if (
          desktopMQ.matches ||
          !state.touch ||
          state.animating
        ) {
          return;
        }


        /*
          Agar koi finger abhi bhi
          screen par hai to ye pinch /
          multi-touch gesture tha.

          Swipe process mat karo.
        */
        if (
          event.touches.length > 0
        ) {

          state.touch = null;

          return;
        }


        const touch =
          event.changedTouches[0];


        if (!touch) {

          state.touch = null;

          return;
        }


        const diffX =
          touch.clientX -
          state.touch.startX;


        const diffY =
          touch.clientY -
          state.touch.startY;


        state.touch = null;


        /*
          Normal tap ya vertical scroll
          ko swipe na samjho.
        */
        if (
          Math.abs(diffX) < 35 ||
          Math.abs(diffX) <=
            Math.abs(diffY) * 1.2
        ) {
          return;
        }


        const baseIndex =
          getBaseIndex(state);


        const otherIndex =
          baseIndex === 0
            ? 1
            : 0;


        /*
          SWIPE LEFT

          View 1:
          Image 1 → Image 2

          View 2:
          Image 2 → Image 1
        */
        if (diffX < 0) {

          slideImage(
            state,
            otherIndex,
            'left'
          );

        }


        /*
          SWIPE RIGHT

          Current selected View ki
          base image restore.
        */
        if (diffX > 0) {

          slideImage(
            state,
            baseIndex,
            'right'
          );

        }


        /*
          Swipe ke baad accidental
          product click block.
        */
        state.suppressClickUntil =
          Date.now() + 350;

      },
      {
        passive: true
      }
    );


    /* =========================================
       TOUCH CANCEL
    ========================================= */

    card.addEventListener(
      'touchcancel',
      () => {

        state.touch = null;

      },
      {
        passive: true
      }
    );


    /* =========================================
       ACCIDENTAL CLICK AFTER SWIPE
    ========================================= */

    card.addEventListener(
      'click',
      (event) => {

        if (
          desktopMQ.matches ||
          Date.now() >=
            state.suppressClickUntil
        ) {
          return;
        }


        event.preventDefault();
        event.stopPropagation();


        state.suppressClickUntil = 0;

      },
      true
    );

  }


  /* =========================================
     SETUP ALL PRODUCT CARDS
  ========================================= */

  function setupAll() {

    document
      .querySelectorAll(selector)
      .forEach(setup);

  }


  /* =========================================
     BOOT
  ========================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      setupAll,
      {
        once: true
      }
    );

  } else {

    setupAll();

  }

})();